import { render, staticRenderFns } from "./diary.vue?vue&type=template&id=4b5f1c94&scoped=true&"
import script from "./diary.vue?vue&type=script&lang=js&"
export * from "./diary.vue?vue&type=script&lang=js&"
import style0 from "./diary.vue?vue&type=style&index=0&id=4b5f1c94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5f1c94",
  null
  
)

export default component.exports